import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { MobileContainer } from '@/components/layout/mobile-container';
import { Header } from '@/components/layout/header';
import { initializeUserSession } from '@/lib/firebase/user-service';
import { useHistoryStore } from '@/lib/store/history-store';
import { logAnalyticsEvent } from '@/lib/firebase/analytics';

// Route components
import DashboardPage from '@/routes/dashboard/DashboardPage';
import SearchAnythingPage from '@/routes/search/anything/SearchAnythingPage';
import SearchAnythingResultPage from '@/routes/search/anything/SearchAnythingResultPage';
import SearchPhotoPage from '@/routes/search/photo/SearchPhotoPage';
import SearchPhotoResultPage from '@/routes/search/photo/SearchPhotoResultPage';
import SearchPersonPage from '@/routes/search/person/SearchPersonPage';
import SearchPersonResultPage from '@/routes/search/person/SearchPersonResultPage';
import AnalyzingPage from '@/routes/analyzing/AnalyzingPage';
import SuccessPage from '@/routes/success/SuccessPage';
import PaywallPage from '@/routes/paywall/PaywallPage';
import HistorySettingsPage from '@/routes/history-settings/HistorySettingsPage';

function AppContent() {
  const loadSearchesFromFirestore = useHistoryStore((state) => state.loadSearchesFromFirestore);
  const location = useLocation();

  useEffect(() => {
    // Log app_open event on initial mount
    logAnalyticsEvent('app_open');

    // Initialize user session and load data from Firestore
    initializeUserSession().then(() => {
      loadSearchesFromFirestore();
    });
  }, [loadSearchesFromFirestore]);

  // Track screen views on route changes
  useEffect(() => {
    const screenName = location.pathname === '/' ? 'dashboard' : location.pathname.slice(1).replace(/\//g, '_');
    logAnalyticsEvent('screen_view', { screen_name: screenName });
  }, [location.pathname]);

  return (
    <MobileContainer>
      <Header />
      <Routes>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/search/anything" element={<SearchAnythingPage />} />
        <Route path="/search/anything/result" element={<SearchAnythingResultPage />} />
        <Route path="/search/photo" element={<SearchPhotoPage />} />
        <Route path="/search/photo/result" element={<SearchPhotoResultPage />} />
        <Route path="/search/person" element={<SearchPersonPage />} />
        <Route path="/search/person/result" element={<SearchPersonResultPage />} />
        <Route path="/analyzing" element={<AnalyzingPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/paywall" element={<PaywallPage />} />
        <Route path="/history-settings" element={<HistorySettingsPage />} />
      </Routes>
    </MobileContainer>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App
